export const HeadingSection = styled.div`
  display: flex;
  height: 192px;
  padding-top: 32px;
  padding-left: 5vw;
  padding-right: 5vw;
  background: #f2f9ff;
`;

// Start of Status button styling

export const StyledDraftStatus = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  width: 130px;
  height: 24px;
  left: calc(50% - 130px / 2 + 667.73px);
  top: calc(50% - 24px / 2 - 192px);
  border-radius: 2px;
  background: #0078d4;
  font-size: 12px;
  font-weight: 600;
  color: #ffffff;
`;

export const StyledSubmittedStatus = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  width: 130px;
  height: 24px;
  left: calc(50% - 130px / 2 + 667.73px);
  top: calc(50% - 24px / 2 - 192px);
  border-radius: 2px;
  background: #fcb72b; // orange
  font-size: 12px;
  font-weight: 600;
  color: #323130; // black
`;

export const StyledRejectedStatus = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  width: 130px;
  height: 24px;
  left: calc(50% - 130px / 2 + 667.73px);
  top: calc(50% - 24px / 2 - 192px);
  border-radius: 2px;
  background: #ff6666; // red
  font-size: 12px;
  font-weight: 600;
  color: #323130; // black
`;

export const StyledApprovedStatus = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  width: 130px;
  height: 24px;
  left: calc(50% - 130px / 2 + 667.73px);
  top: calc(50% - 24px / 2 - 192px);
  border-radius: 2px;
  background: #caefc1; // green
  font-size: 12px;
  font-weight: 600;
  color: #323130; // black
`;

export const StyledProvisionedStatus = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  width: 130px;
  height: 24px;
  left: calc(50% - 130px / 2 + 667.73px);
  top: calc(50% - 24px / 2 - 192px);
  border-radius: 2px;
  background: #caefc1; // green
  font-size: 12px;
  font-weight: 600;
  color: #323130; // black
`;
// End of Status button styling

// Common button
export const CancelButtonStyles = {
  root: {
    size: '16px',
    height: '16px',
    width: '16px',
    color: '#000',
    margin: '0px 0px 0px 0px',
  },
};
